import { z } from "zod"
import { MANUAL_ADDRESS } from "@/modules/patients/components/header/emergency-service/emergency-service-dialog"

const EmergencyServiceSchema = z
  .object({
    patientAddress: z.string(),
    country: z.string(),
    postalCode: z.string(),
    city: z.string(),
    houseNumberStreet: z.string(),
  })
  .superRefine(({ patientAddress, postalCode, city, houseNumberStreet }, ctx) => {
    if (patientAddress === MANUAL_ADDRESS) {
      if (!postalCode) {
        ctx.addIssue({
          code: "custom",
          path: ["postalCode"],
          message: "common.fieldErrorList.requiredField",
        })
      }
      if (!city) {
        ctx.addIssue({
          code: "custom",
          path: ["city"],
          message: "common.fieldErrorList.requiredField",
        })
      }
      if (houseNumberStreet?.length > 150) {
        ctx.addIssue({
          code: "custom",
          path: ["houseNumberStreet"],
          message: "common.fieldErrorList.characterLimit",
        })
      }
    }
  })
type EmergencyServiceSchemaType = z.infer<typeof EmergencyServiceSchema>
export { type EmergencyServiceSchemaType, EmergencyServiceSchema }
